export const CSS = `
/* ── Google Fonts loaded via <link> in index.html for better performance ── */

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}

:root {
  --blue:#2563EB;
  --blue-lt:#3B82F6;
  --blue-dk:#1D4ED8;
  --blue-xl:#EFF6FF;
  --blue-md:#DBEAFE;
  --blue-deep:#1E3A8A;
  --ink:#0F172A;
  --ink2:#1E293B;
  --body:#334155;
  --muted:#64748B;
  --soft:#94A3B8;
  --bg:#F8FAFC;
  --bg2:#F1F5F9;
  --white:#FFFFFF;
  --border:#E2E8F0;
  --border2:#CBD5E1;
  --green:#16A34A;
  --green-lt:#DCFCE7;
  --amber:#D97706;
  --amber-lt:#FEF3C7;
  --sh-sm:0 1px 3px rgba(15,23,42,.06),0 1px 2px rgba(15,23,42,.08);
  --sh:0 4px 16px rgba(15,23,42,.08),0 2px 4px rgba(15,23,42,.05);
  --sh-lg:0 20px 60px rgba(15,23,42,.10),0 8px 24px rgba(15,23,42,.06);
  --sh-blue:0 8px 32px rgba(37,99,235,.22),0 2px 8px rgba(37,99,235,.12);
  --r:10px; --rl:16px;
}

html{scroll-behavior:smooth;overflow-x:hidden;max-width:100vw}
body{
  font-family:'DM Sans',sans-serif;
  background:var(--white);color:var(--body);
  -webkit-font-smoothing:antialiased;
  overflow-x:hidden;max-width:100vw;
}
#root{overflow-x:hidden;max-width:100vw}
::-webkit-scrollbar{width:5px}
::-webkit-scrollbar-track{background:var(--bg2)}
::-webkit-scrollbar-thumb{background:linear-gradient(180deg,var(--blue-lt),var(--blue-dk));border-radius:3px}

/* ── Utils ── */
.j{font-family:'Plus Jakarta Sans',sans-serif}
.wrap{max-width:1120px;margin:0 auto;padding:0 1.5rem}
.sec{padding:5.5rem 1.5rem;overflow:hidden}
.tc{text-align:center}

.chip{
  display:inline-flex;align-items:center;gap:.4rem;
  font-size:.68rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;
  color:var(--blue);background:var(--blue-xl);
  padding:.28rem .8rem;border-radius:100px;margin-bottom:1.1rem;
  border:1px solid var(--blue-md);
}
.chip.g{color:var(--green);background:var(--green-lt);border-color:rgba(22,163,74,.2)}
.chip.a{color:var(--amber);background:var(--amber-lt);border-color:rgba(217,119,6,.2)}

.h1{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:clamp(2.4rem,5vw,3.8rem);font-weight:800;
  color:var(--ink);line-height:1.04;letter-spacing:-.04em;margin-bottom:1.1rem;
}
.h1 mark,.h2 mark{
  background:linear-gradient(104deg,
    rgba(37,99,235,0) 0.9%,
    rgba(37,99,235,0.15) 2.4%,
    rgba(59,130,246,0.12) 5.8%,
    rgba(219,234,254,0.6) 93%,
    rgba(37,99,235,0) 96%);
  border-radius:4px;
  color:var(--blue-dk);
  padding:.04em .18em;
  box-decoration-break:clone;-webkit-box-decoration-break:clone;
  position:relative;
}
.h2{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:clamp(1.8rem,3.5vw,2.6rem);font-weight:800;
  color:var(--ink);line-height:1.1;letter-spacing:-.03em;margin-bottom:.65rem;
}
.lead{font-size:1.05rem;color:var(--muted);line-height:1.8;max-width:560px}
.lead.c{margin:0 auto}

/* ── Buttons ── */
.btn{
  display:inline-flex;align-items:center;gap:.5rem;
  font-family:'Plus Jakarta Sans',sans-serif;font-size:.85rem;font-weight:700;
  letter-spacing:-.01em;padding:.78rem 1.6rem;
  border:none;cursor:pointer;text-decoration:none;border-radius:var(--r);
  transition:all .22s ease;white-space:nowrap;
}
.btn-p{background:linear-gradient(135deg,var(--blue) 0%,var(--blue-dk) 100%);color:#fff;box-shadow:var(--sh-blue)}
.btn-p:hover{background:linear-gradient(135deg,var(--blue-lt) 0%,var(--blue) 100%);transform:translateY(-2px);box-shadow:0 12px 36px rgba(37,99,235,.38)}
.btn-o{background:transparent;color:var(--blue);border:1.5px solid var(--border2)}
.btn-o:hover{border-color:var(--blue);background:var(--blue-xl);color:var(--blue-dk)}
.btn-w{background:#fff;color:var(--ink);box-shadow:var(--sh)}
.btn-w:hover{transform:translateY(-2px);box-shadow:var(--sh-lg)}
.btn-lg{padding:1rem 2.2rem;font-size:.95rem}
.btn-sm{padding:.52rem 1.1rem;font-size:.78rem}

/* ── NAV ── */
.nav{
  position:fixed;top:0;left:0;right:0;z-index:400;
  background:rgba(255,255,255,.94);backdrop-filter:blur(24px) saturate(180%);
  -webkit-backdrop-filter:blur(24px) saturate(180%);
  border-bottom:1px solid transparent;
  transition:border-color .3s,box-shadow .3s;
}
.nav.sc{border-bottom-color:var(--border);box-shadow:0 2px 12px rgba(15,23,42,.06)}
.nav-in{
  max-width:1120px;margin:0 auto;padding:0 1.5rem;
  display:flex;align-items:center;justify-content:space-between;height:62px;
}
.nav-logo{display:flex;align-items:center;gap:.6rem;text-decoration:none;cursor:pointer;border:none;background:none;padding:0}
.nav-links{display:flex;align-items:center;gap:.15rem;list-style:none}
.nav-links button,.nav-links a{
  background:none;border:none;cursor:pointer;
  font-family:'DM Sans',sans-serif;font-size:.87rem;font-weight:500;
  color:var(--body);padding:.48rem .85rem;border-radius:8px;transition:all .2s;
  text-decoration:none;display:inline-block;
}
.nav-links button:hover,.nav-links a:hover{color:var(--ink);background:var(--bg2)}
.nav-links button.act,.nav-links a.act{color:var(--blue);background:var(--blue-xl);font-weight:600}
.nav-r{display:flex;align-items:center;gap:.6rem}
.nav-r .btn{font-size:.85rem;font-weight:700;padding:.58rem 1.2rem;border-radius:10px}
.hb{display:none;flex-direction:column;gap:4px;background:none;border:none;cursor:pointer;padding:.35rem}
.hb span{display:block;width:20px;height:1.5px;background:var(--ink);border-radius:2px;transition:all .3s}
.mob{display:none;position:fixed;inset:0;background:#fff;z-index:399;flex-direction:column;padding:1.5rem}
.mob.open{display:flex}
.mob-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:2.5rem}
.mob-links{display:flex;flex-direction:column;gap:.5rem}
.mob-links button,.mob-links a{
  background:none;border:none;cursor:pointer;text-align:left;
  font-family:'Plus Jakarta Sans',sans-serif;font-size:1.3rem;font-weight:700;
  color:var(--ink);padding:.7rem 0;border-bottom:1px solid var(--border);transition:color .2s;
  text-decoration:none;display:block;
}
.mob-links button:hover,.mob-links a:hover{color:var(--blue)}
.mob-cta{display:flex;flex-direction:column;gap:.75rem;margin-top:2rem}
@media(max-width:840px){
  .nav-links{display:none}
  .hb{display:flex}
}

/* ── HERO ── */
.hero{
  padding:9rem 1.5rem 5rem;
  background:
    radial-gradient(ellipse 80% 60% at 70% -10%, rgba(59,130,246,.13) 0%, transparent 60%),
    radial-gradient(ellipse 60% 50% at -10% 80%, rgba(37,99,235,.08) 0%, transparent 55%),
    linear-gradient(160deg,#fff 0%,#EFF6FF 55%,#DBEAFE 100%);
  position:relative;overflow:hidden;
  width:100%;box-sizing:border-box;
}
/* Decorative geometric shapes */
.hero::before{
  content:'';position:absolute;top:-6%;right:-4%;
  width:48vw;height:48vw;border-radius:50%;
  background:radial-gradient(circle at 40% 40%,rgba(37,99,235,.10) 0%,rgba(59,130,246,.04) 50%,transparent 70%);
  pointer-events:none;
}
.hero::after{
  content:'';position:absolute;bottom:-8%;left:-5%;
  width:36vw;height:36vw;border-radius:50%;
  background:radial-gradient(circle,rgba(29,78,216,.06) 0%,transparent 65%);
  pointer-events:none;
}
/* Subtle dot grid pattern */
.hero-grid{
  position:absolute;inset:0;pointer-events:none;z-index:0;
  background-image:radial-gradient(circle,rgba(37,99,235,.10) 1px,transparent 1px);
  background-size:28px 28px;
  mask-image:linear-gradient(to bottom right,transparent 20%,rgba(0,0,0,.4) 50%,transparent 80%);
  -webkit-mask-image:linear-gradient(to bottom right,transparent 20%,rgba(0,0,0,.4) 50%,transparent 80%);
}
.hero-in{
  max-width:1120px;margin:0 auto;
  display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,.9fr);gap:3rem;align-items:center;
  position:relative;z-index:1;
}
.hero-in > *{min-width:0}
.hero-kicker{
  display:inline-flex;align-items:center;gap:.5rem;
  font-size:.7rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;
  color:var(--blue);background:var(--blue-xl);
  padding:.32rem .9rem;border-radius:100px;margin-bottom:1.4rem;
  border:1px solid var(--blue-md);box-shadow:0 1px 4px rgba(37,99,235,.12);
}
.hero-kicker-dot{width:7px;height:7px;border-radius:50%;background:var(--green);flex-shrink:0;animation:bk 2s infinite}
@keyframes bk{0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(22,163,74,.4)}60%{opacity:.4;box-shadow:0 0 0 5px rgba(22,163,74,0)}}
.hero-p{font-size:1.08rem;color:var(--muted);line-height:1.82;margin-bottom:2.2rem;max-width:490px}
.hero-btns{display:flex;gap:.75rem;flex-wrap:wrap;align-items:center;margin-bottom:2.25rem}
.hero-proof{display:flex;flex-wrap:wrap;gap:1.5rem}
.proof-i{display:flex;align-items:center;gap:.45rem;font-size:.82rem;color:var(--muted)}
.proof-i svg{color:var(--green);flex-shrink:0}
.hero-tp{display:flex;flex-wrap:wrap;align-items:center;gap:.6rem 1rem;margin-top:1.4rem}
.hero-tp-logo{display:inline-flex;align-items:center;gap:.4rem;padding:.45rem .8rem;background:#fff;border:1px solid var(--border);border-radius:10px;text-decoration:none;transition:transform .2s,box-shadow .2s,border-color .2s}
.hero-tp-logo:hover{transform:translateY(-2px);border-color:#00b67a;box-shadow:0 6px 18px rgba(0,182,122,.18)}
.hero-tp-logo svg{flex-shrink:0}
.hero-tp-name{font-family:'Plus Jakarta Sans',sans-serif;font-size:.95rem;font-weight:800;color:#191919;letter-spacing:-.01em}
.hero-tp-links{display:flex;flex-wrap:wrap;gap:.35rem 1rem;font-size:.82rem}
.hero-tp-links a{color:var(--muted);text-decoration:underline;text-underline-offset:3px;text-decoration-color:rgba(100,116,139,.35);transition:color .2s}
.hero-tp-links a:hover{color:#00875a;text-decoration-color:currentColor}

/* ── HERO: rating con avatar ── */
.hero-rating{display:flex;align-items:center;gap:.7rem;margin-bottom:1.6rem}
.hr-avatars{display:flex;flex-shrink:0}
.hr-avatars span{
  width:1.9rem;height:1.9rem;border-radius:50%;border:2px solid #fff;margin-left:-.55rem;
  display:flex;align-items:center;justify-content:center;
  font-family:'Plus Jakarta Sans',sans-serif;font-size:.62rem;font-weight:800;color:#fff;
  box-shadow:0 1px 4px rgba(15,23,42,.18);
}
.hr-avatars span:first-child{margin-left:0}
.hr-stars{display:flex;gap:1px;color:var(--amber)}
.hr-txt{font-size:.8rem;color:var(--muted)}
.hr-txt b{color:var(--ink);font-weight:800}

/* ── HERO: badge fluttuante ── */
.hero-badge{
  position:absolute;left:-1.1rem;bottom:1.6rem;z-index:2;
  background:#fff;border-radius:14px;
  box-shadow:var(--sh-lg),0 0 0 1px var(--border);
  padding:.7rem .95rem;display:flex;align-items:center;gap:.65rem;
  max-width:215px;animation:heroFloat 3.6s ease-in-out infinite;
}
.hero-badge-ic{
  width:2.15rem;height:2.15rem;border-radius:9px;flex-shrink:0;
  background:linear-gradient(135deg,var(--green-lt),rgba(22,163,74,.2));
  color:var(--green);
  display:flex;align-items:center;justify-content:center;
}
.hero-badge-t{font-family:'Plus Jakarta Sans',sans-serif;font-size:.74rem;font-weight:800;color:var(--ink);line-height:1.25}
.hero-badge-s{font-size:.66rem;color:var(--muted);margin-top:.1rem}
@keyframes heroFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-9px)}}

/* ── BROWSER MOCK ── */
.browser{
  background:#fff;border-radius:14px;
  box-shadow:var(--sh-lg),0 0 0 1px var(--border);overflow:hidden;
  position:relative;width:100%;min-width:0;
}
.bb{display:flex;align-items:center;gap:.5rem;padding:.6rem 1rem;background:var(--bg2);border-bottom:1px solid var(--border)}
.bd{width:9px;height:9px;border-radius:50%}
.bu{flex:1;background:#fff;border:1px solid var(--border);padding:.22rem .65rem;border-radius:6px;font-size:.67rem;color:var(--muted);display:flex;align-items:center;gap:.3rem}
.bu svg{width:10px;height:10px;color:var(--green)}
.btb{display:flex;justify-content:space-between;align-items:center;padding:.8rem 1.1rem;background:#fff;border-bottom:1px solid var(--border)}
.blogo{font-family:'Plus Jakarta Sans',sans-serif;font-size:.8rem;font-weight:800;color:var(--blue)}
.bbtn{font-size:.62rem;font-weight:700;padding:.28rem .65rem;border-radius:6px;background:linear-gradient(135deg,var(--blue),var(--blue-dk));color:#fff}
.bbtn.g{background:transparent;border:1px solid var(--border2);color:var(--muted)}
.bha{padding:1.1rem 1.1rem .8rem;background:linear-gradient(135deg,var(--blue-xl),#fff)}
.bha h4{font-family:'Plus Jakarta Sans',sans-serif;font-size:.85rem;font-weight:800;color:var(--ink);margin-bottom:.25rem}
.bha p{font-size:.68rem;color:var(--muted);margin-bottom:.75rem}
.bsr{display:flex;align-items:center;background:#fff;border:1.5px solid var(--blue);border-radius:8px;overflow:hidden;box-shadow:0 0 0 3px rgba(37,99,235,.08)}
.bsr input{flex:1;border:none;outline:none;font-size:.68rem;color:var(--muted);padding:.38rem .6rem;font-family:'DM Sans',sans-serif;background:transparent}
.bsb{background:linear-gradient(135deg,var(--blue),var(--blue-dk));color:#fff;font-size:.63rem;font-weight:700;padding:.4rem .7rem;white-space:nowrap}
.bcars{display:grid;grid-template-columns:1fr 1fr;gap:.65rem;padding:.85rem 1.1rem;background:var(--bg)}
.bcar{background:#fff;border-radius:8px;border:1px solid var(--border);padding:.7rem;box-shadow:var(--sh-sm)}
.bci{height:46px;border-radius:6px;background:linear-gradient(135deg,var(--blue-xl),var(--blue-md));display:flex;align-items:center;justify-content:center;margin-bottom:.5rem}
.bci svg{width:1.5rem;height:1.5rem;color:var(--blue);opacity:.75}
.bcn{font-family:'Plus Jakarta Sans',sans-serif;font-size:.68rem;font-weight:700;color:var(--ink)}
.bcp{font-size:.62rem;color:var(--blue);font-weight:600;margin:.1rem 0 .42rem}
.bcb{display:block;width:100%;text-align:center;font-size:.6rem;font-weight:700;background:linear-gradient(135deg,var(--blue),var(--blue-dk));color:#fff;padding:.28rem;border-radius:5px}
.blive{position:absolute;top:.8rem;right:.8rem;background:var(--green);color:#fff;font-size:.58rem;font-weight:800;letter-spacing:.08em;padding:.22rem .6rem;border-radius:100px;box-shadow:0 2px 6px rgba(22,163,74,.4)}

/* ── STATS BAR ── */
.sbar{
  background:#fff;
  border-top:1px solid var(--border);
  border-bottom:1px solid var(--border);
  padding:0 1.5rem;overflow:hidden;
  position:relative;
}
.sbar::before{
  content:'';position:absolute;inset:0;
  background:linear-gradient(90deg,var(--blue-xl) 0%,transparent 30%,transparent 70%,var(--blue-xl) 100%);
  pointer-events:none;opacity:.5;
}
.sbar-in{max-width:1120px;margin:0 auto;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));position:relative}
.si{padding:2rem 1.5rem;text-align:center;border-right:1px solid var(--border);position:relative}
.si:last-child{border-right:none}
.si-n{font-family:'Plus Jakarta Sans',sans-serif;font-size:2.3rem;font-weight:800;
  background:linear-gradient(135deg,var(--blue) 0%,var(--blue-dk) 100%);
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
  letter-spacing:-.04em;line-height:1.2;padding-bottom:.08em;margin-bottom:-.28em}
.si-l{font-size:.8rem;color:var(--muted);margin-top:.35rem;font-weight:500}

/* ── PARTNER BAR ──────────────────────────────────────────────────────────
   Tile su griglia, non loghi nudi: stessa grammatica visiva delle .fc
   (card bianca, hairline, filetto blu in hover, sollevamento di 3px).
   ────────────────────────────────────────────────────────────────────── */
.pbar{
  background:var(--bg);
  border-top:1px solid var(--border);
  border-bottom:1px solid var(--border);
  padding:4rem 1.5rem;
  position:relative;overflow:hidden;
}
/* Trama a puntini, la stessa dell'hero, ma appena percettibile */
.pbar::before{
  content:'';position:absolute;inset:0;pointer-events:none;
  background-image:radial-gradient(circle,rgba(37,99,235,.08) 1px,transparent 1px);
  background-size:26px 26px;
  mask-image:radial-gradient(ellipse 70% 100% at 50% 50%,#000 20%,transparent 75%);
  -webkit-mask-image:radial-gradient(ellipse 70% 100% at 50% 50%,#000 20%,transparent 75%);
}
.pbar .wrap{position:relative;z-index:1}

.pbar-head{text-align:center;margin-bottom:2.5rem}
.pbar-title{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:clamp(1.35rem,2.4vw,1.7rem);font-weight:800;
  color:var(--ink);letter-spacing:-.03em;line-height:1.2;margin-bottom:.5rem;
}
.pbar-sub{
  font-size:.92rem;color:var(--muted);line-height:1.7;
  max-width:460px;margin:0 auto;
}

.pbar-logos{
  display:grid;
  grid-template-columns:repeat(6,minmax(0,1fr));
  gap:.9rem;
}
.plogo{
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:.85rem;
  background:var(--white);
  border:1.5px solid var(--border);
  border-radius:var(--rl);
  padding:1.5rem .75rem 1.15rem;
  position:relative;overflow:hidden;
  transition:border-color .3s ease,box-shadow .3s ease,transform .3s ease;
  cursor:default;min-width:0;
}
/* Filetto superiore: identico a .fc::before */
.plogo::before{
  content:'';position:absolute;top:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,var(--blue),var(--blue-lt));
  opacity:0;transition:opacity .3s;
}
.plogo:hover{
  border-color:rgba(37,99,235,.3);
  box-shadow:0 10px 30px rgba(37,99,235,.10);
  transform:translateY(-3px);
}
.plogo:hover::before{opacity:1}

.plogo-img{
  display:flex;align-items:center;justify-content:center;
  height:32px;width:100%;
  filter:grayscale(1);opacity:.45;
  transition:filter .3s ease,opacity .3s ease;
}
.plogo-img svg,.plogo-img img{max-width:100%;height:auto;max-height:32px;display:block}
.plogo:hover .plogo-img{filter:grayscale(0);opacity:1}

.plogo-name{
  font-size:.64rem;font-weight:700;letter-spacing:.11em;
  color:var(--soft);text-transform:uppercase;
  text-align:center;line-height:1.35;
  transition:color .3s ease;
}
.plogo:hover .plogo-name{color:var(--muted)}

/* Nota di chiusura sotto la griglia */
.pbar-note{
  display:flex;align-items:center;justify-content:center;gap:.5rem;
  margin-top:2.25rem;
  font-size:.82rem;color:var(--soft);
}
.pbar-note svg{color:var(--green);flex-shrink:0}

@media(max-width:1000px){
  .pbar-logos{grid-template-columns:repeat(3,minmax(0,1fr))}
}
@media(max-width:768px){
  .pbar{padding:3.25rem 1.25rem}
  .pbar-head{margin-bottom:2rem}
}
@media(max-width:560px){
  .pbar-logos{grid-template-columns:repeat(2,minmax(0,1fr));gap:.7rem}
  .plogo{padding:1.25rem .6rem 1rem;gap:.7rem}
  .plogo-img{height:28px}
  .plogo-img svg,.plogo-img img{max-height:28px}
  .plogo-name{font-size:.6rem;letter-spacing:.08em}
}

/* ── FEATURE CARDS ── */
.fg{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1.25rem;margin-top:3.25rem}
.fc{
  background:#fff;border:1.5px solid var(--border);border-radius:var(--rl);
  padding:1.75rem;transition:all .3s ease;min-width:0;
  position:relative;overflow:hidden;
}
.fc::before{
  content:'';position:absolute;top:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,var(--blue),var(--blue-lt));
  opacity:0;transition:opacity .3s;
}
.fc:hover{border-color:rgba(37,99,235,.3);box-shadow:0 12px 36px rgba(37,99,235,.1);transform:translateY(-4px)}
.fc:hover::before{opacity:1}
.fi{
  width:2.8rem;height:2.8rem;border-radius:12px;
  display:flex;align-items:center;justify-content:center;
  margin-bottom:1.1rem;color:var(--blue);
  background:linear-gradient(135deg,var(--blue-xl) 0%,var(--blue-md) 100%);
  box-shadow:0 2px 8px rgba(37,99,235,.15);
}
.fi.g{background:linear-gradient(135deg,var(--green-lt) 0%,rgba(22,163,74,.15) 100%);color:var(--green);box-shadow:0 2px 8px rgba(22,163,74,.15)}
.fi.a{background:linear-gradient(135deg,var(--amber-lt) 0%,rgba(217,119,6,.15) 100%);color:var(--amber);box-shadow:0 2px 8px rgba(217,119,6,.15)}
.ft{font-family:'Plus Jakarta Sans',sans-serif;font-size:.97rem;font-weight:700;color:var(--ink);margin-bottom:.42rem}
.fd{font-size:.87rem;color:var(--muted);line-height:1.72}

/* ── STEPS ── */
.sg{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:1.5rem;margin-top:3.25rem}
.sc-card{
  background:#fff;border:1.5px solid var(--border);border-radius:var(--rl);
  padding:1.85rem;display:flex;gap:1.2rem;transition:all .3s;min-width:0;
}
.sc-card:hover{border-color:rgba(37,99,235,.3);box-shadow:0 8px 24px rgba(37,99,235,.08);transform:translateY(-2px)}
.snum{
  width:2.5rem;height:2.5rem;flex-shrink:0;border-radius:10px;
  background:linear-gradient(135deg,var(--blue) 0%,var(--blue-dk) 100%);
  display:flex;align-items:center;justify-content:center;
  font-family:'Plus Jakarta Sans',sans-serif;font-size:1rem;font-weight:800;color:#fff;
  box-shadow:0 4px 12px rgba(37,99,235,.3);
}
.sb{min-width:0}
.sb h3{font-family:'Plus Jakarta Sans',sans-serif;font-size:.97rem;font-weight:700;color:var(--ink);margin-bottom:.38rem}
.sb p{font-size:.87rem;color:var(--muted);line-height:1.72}

/* ── PRICING ── */
.pg{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1.5rem;margin-top:3.5rem;align-items:stretch}
.pc{
  background:#fff;border:1.5px solid var(--border);border-radius:var(--rl);
  padding:2rem;position:relative;transition:all .3s;min-width:0;
  display:flex;flex-direction:column;
}
.pc-cta{margin-top:auto}
.pc:hover{box-shadow:var(--sh-lg)}
.pc.pop{
  border-color:var(--blue);border-width:2px;
  box-shadow:0 16px 48px rgba(37,99,235,.18);
  transform:translateY(-8px);
  background:linear-gradient(160deg,#fff 0%,var(--blue-xl) 100%);
}

/* Badge "più scelto" */
.pop-badge{
  position:absolute;top:-14px;left:50%;transform:translateX(-50%);
  background:linear-gradient(135deg,var(--blue) 0%,var(--blue-dk) 100%);color:#fff;
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:.65rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;
  padding:.32rem 1rem;border-radius:100px;white-space:nowrap;
  box-shadow:0 4px 12px rgba(37,99,235,.4);
}

/* Tag colorato sotto badge */
.ptag{
  display:inline-flex;align-items:center;gap:.35rem;
  font-size:.7rem;font-weight:700;padding:.25rem .7rem;border-radius:100px;
  margin-bottom:1rem;
}
.ptag.free{background:var(--green-lt);color:var(--green)}
.ptag.warn{background:var(--amber-lt);color:var(--amber)}
.ptag.best{background:var(--blue-xl);color:var(--blue)}

/* ── PRICE HEADER ── */
.price-header{
  margin-bottom:1rem;
  padding-bottom:1rem;
  border-bottom:1px solid var(--border);
}
.price-tier{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:.68rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;
  color:var(--muted);
  display:block;
  margin-bottom:.6rem;
}
.price-row{
  display:flex;align-items:flex-end;gap:.15rem;
  line-height:1;
}
.price-currency{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:1.3rem;font-weight:700;color:var(--ink);
  padding-bottom:.3rem;
}
.price-number{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:3rem;font-weight:800;color:var(--ink);
  letter-spacing:-.04em;line-height:1;
}
.pc.pop .price-number{
  background:linear-gradient(135deg,var(--blue) 0%,var(--blue-dk) 100%);
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
}
.price-cents{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:1.3rem;font-weight:700;color:var(--ink);
  padding-bottom:.3rem;
}
.price-period{
  font-size:.82rem;color:var(--muted);
  margin-top:.4rem;
  display:block;
}

/* Note box */
.pnote{
  font-size:.81rem;color:var(--body);background:var(--bg2);
  border-radius:8px;padding:.65rem .85rem;margin-bottom:1.25rem;
  border-left:3px solid var(--border2);line-height:1.6;
}
.pnote.warn{border-left-color:var(--amber);background:var(--amber-lt);color:#92400E}
.pnote.ok{border-left-color:var(--green);background:var(--green-lt);color:#14532D}

/* List */
.pl{list-style:none;display:flex;flex-direction:column;gap:.65rem;margin-bottom:1.85rem}
.pl li{display:flex;align-items:flex-start;gap:.5rem;font-size:.87rem;color:var(--body);line-height:1.45}
.ck{color:var(--green);flex-shrink:0;margin-top:.05rem;font-size:.9rem;font-weight:700}
.cx{color:var(--soft);flex-shrink:0;margin-top:.05rem;font-size:.9rem}

/* ── COMPARE TABLE ── */
.ctw{margin-top:4rem;background:#fff;border:1.5px solid var(--border);border-radius:var(--rl);overflow:hidden;box-shadow:var(--sh-sm)}
.cth{display:grid;grid-template-columns:minmax(0,2fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr);background:var(--bg2);border-bottom:1.5px solid var(--border)}
.cth div{padding:.9rem 1.1rem;font-family:'Plus Jakarta Sans',sans-serif;font-size:.8rem;font-weight:700;color:var(--ink)}
.cth div:first-child{color:var(--muted);font-weight:500}
.ctr{display:grid;grid-template-columns:minmax(0,2fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr);border-bottom:1px solid var(--border);transition:background .18s}
.ctr:last-child{border-bottom:none}
.ctr:hover{background:var(--bg)}
.ctr div{padding:.82rem 1.1rem;font-size:.86rem;color:var(--body);display:flex;align-items:center}
.ctr div:first-child{color:var(--ink);font-weight:500}
.tg{color:var(--green);font-weight:700}
.tx{color:var(--soft)}

/* ── TESTIMONIALS ── */
.tg2{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1.25rem;margin-top:3rem}
.tc2{
  background:#fff;border:1.5px solid var(--border);border-radius:var(--rl);
  padding:1.75rem;transition:all .3s;min-width:0;
  position:relative;
}
.tc2::before{
  content:'“';position:absolute;top:.8rem;left:1.4rem;
  font-family:'Plus Jakarta Sans',sans-serif;font-size:4rem;line-height:1;
  color:var(--blue-md);font-weight:800;pointer-events:none;
}
.tc2:hover{border-color:rgba(37,99,235,.3);box-shadow:0 8px 28px rgba(37,99,235,.09);transform:translateY(-2px)}
.tstars{display:flex;gap:.2rem;margin-bottom:1.1rem;color:#F59E0B}
.tq{font-size:.93rem;color:var(--ink2);line-height:1.78;margin-bottom:1.35rem;padding-top:.5rem}
.tau{display:flex;align-items:center;gap:.75rem;padding-top:.75rem;border-top:1px solid var(--border)}
.tav{
  width:2.5rem;height:2.5rem;border-radius:50%;
  background:linear-gradient(135deg,var(--blue) 0%,var(--blue-dk) 100%);
  display:flex;align-items:center;justify-content:center;
  font-family:'Plus Jakarta Sans',sans-serif;font-size:.82rem;font-weight:800;color:#fff;
  flex-shrink:0;box-shadow:0 2px 8px rgba(37,99,235,.3);
}
.tan{font-family:'Plus Jakarta Sans',sans-serif;font-size:.86rem;font-weight:700;color:var(--ink)}
.tar{font-size:.78rem;color:var(--muted);margin-top:.1rem}

/* ── FAQ ── */
.fw{max-width:680px;margin:3rem auto 0}
.fi2{background:#fff;border:1.5px solid var(--border);border-radius:var(--r);margin-bottom:.65rem;overflow:hidden;transition:all .25s}
.fi2:hover,.fi2.op{border-color:rgba(37,99,235,.3);box-shadow:0 4px 16px rgba(37,99,235,.07)}
.fq{
  display:flex;justify-content:space-between;align-items:center;
  gap:1rem;width:100%;background:none;border:none;text-align:left;cursor:pointer;padding:1.2rem 1.35rem;
}
.fqt{font-family:'Plus Jakarta Sans',sans-serif;font-size:.93rem;font-weight:600;color:var(--ink)}
.fic{flex-shrink:0;width:1.5rem;height:1.5rem;background:var(--bg2);border-radius:7px;display:flex;align-items:center;justify-content:center;color:var(--blue);font-size:.78rem;font-weight:700;transition:transform .28s,background .28s}
.fi2.op .fic{transform:rotate(45deg);background:var(--blue-xl)}
.fa{max-height:0;overflow:hidden;transition:max-height .38s ease,padding .28s;font-size:.89rem;color:var(--muted);line-height:1.8}
.fa.op{max-height:400px;padding:.2rem 1.35rem 1.2rem}

/* ── CONTACT ── */
.cg{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:4rem;align-items:start}
.cii{display:flex;gap:1rem;align-items:flex-start;padding:1.2rem;background:#fff;border:1.5px solid var(--border);border-radius:var(--r);margin-bottom:.7rem;transition:all .25s}
.cii:hover{border-color:rgba(37,99,235,.3);box-shadow:0 4px 16px rgba(37,99,235,.08);transform:translateX(3px)}
.cico{width:2.6rem;height:2.6rem;flex-shrink:0;background:linear-gradient(135deg,var(--blue-xl),var(--blue-md));border-radius:10px;display:flex;align-items:center;justify-content:center;color:var(--blue)}
.fcard{background:#fff;border:1.5px solid var(--border);border-radius:var(--rl);padding:2.25rem;box-shadow:var(--sh-sm)}
.fg2{margin-bottom:1rem}
.fl{display:block;font-size:.75rem;font-weight:600;color:var(--ink2);letter-spacing:.04em;margin-bottom:.42rem}
.fo{
  width:100%;background:var(--bg);border:1.5px solid var(--border);border-radius:var(--r);
  color:var(--ink);font-family:'DM Sans',sans-serif;font-size:.91rem;
  padding:.72rem 1rem;outline:none;transition:border-color .22s,box-shadow .22s,background .22s;
}
.fo:focus{border-color:var(--blue);box-shadow:0 0 0 4px rgba(37,99,235,.12);background:#fff}
.fo::placeholder{color:var(--soft)}
textarea.fo{resize:vertical;min-height:96px}

/* ── CTA BAND ── */
.cta{
  background:linear-gradient(135deg,var(--blue-deep) 0%,var(--blue) 50%,var(--blue-lt) 100%);
  padding:5.5rem 1.5rem;text-align:center;position:relative;overflow:hidden;
}
.cta::before{
  content:'';pointer-events:none;position:absolute;inset:0;
  background:
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Ccircle cx='30' cy='30' r='1.5'/%3E%3C/g%3E%3C/svg%3E"),
    radial-gradient(ellipse 80% 50% at 50% 120%,rgba(255,255,255,.08) 0%,transparent 60%);
}
.cta::after{
  content:'';pointer-events:none;position:absolute;
  top:-40%;right:-15%;width:55%;height:200%;
  background:radial-gradient(ellipse,rgba(255,255,255,.07) 0%,transparent 60%);
  border-radius:50%;
}
.cta h2{
  font-family:'Plus Jakarta Sans',sans-serif;
  font-size:clamp(1.85rem,4.5vw,3rem);font-weight:800;
  color:#fff;line-height:1.1;letter-spacing:-.03em;
  margin-bottom:.7rem;position:relative;z-index:1;
  text-shadow:0 2px 12px rgba(15,23,42,.15);
}
.cta p{font-size:1.05rem;color:rgba(255,255,255,.78);margin-bottom:2.1rem;position:relative;z-index:1}
.cta .btn-w{color:var(--blue-dk);font-weight:800;position:relative;z-index:1}
.cta .btn-w:hover{transform:translateY(-2px);box-shadow:0 12px 36px rgba(15,23,42,.2)}

/* ── PAGE HERO ── */
.ph{
  padding:8rem 1.5rem 4rem;
  background:
    radial-gradient(ellipse 70% 50% at 80% 0%,rgba(59,130,246,.1) 0%,transparent 55%),
    linear-gradient(160deg,#fff 0%,var(--blue-xl) 60%,var(--blue-md) 100%);
  overflow:hidden;position:relative;
}
.ph::before{
  content:'';position:absolute;inset:0;
  background-image:radial-gradient(circle,rgba(37,99,235,.08) 1px,transparent 1px);
  background-size:32px 32px;
  mask-image:linear-gradient(to bottom,transparent 0%,rgba(0,0,0,.3) 40%,transparent 100%);
  -webkit-mask-image:linear-gradient(to bottom,transparent 0%,rgba(0,0,0,.3) 40%,transparent 100%);
  pointer-events:none;
}
.ph-in{max-width:1120px;margin:0 auto;position:relative;z-index:1}

/* ── BREADCRUMB ── */
/* .bc precede sempre una .ph (hero di pagina): il suo stesso padding-top
   di 8rem serve a scostarsi dalla navbar fixed, quindi quando c'è un
   breadcrumb sopra basta molto meno spazio (la regola "+" sotto lo riduce). */
.bc{padding:5.4rem 1.5rem 0;background:#fff}
.bc-list{list-style:none;display:flex;flex-wrap:wrap;align-items:center;gap:.4rem;margin:0 auto;padding:.85rem 0;max-width:1120px;font-size:.82rem;color:var(--muted)}
.bc-list li{display:flex;align-items:center;gap:.4rem}
.bc-list a{color:var(--muted);text-decoration:none}
.bc-list a:hover{color:var(--blue);text-decoration:underline}
.bc-sep{color:var(--border2,#CBD5E1)}
.bc-current{color:var(--ink);font-weight:600}
.bc + .ph{padding-top:2.5rem}

/* ── FOOTER ── */
footer{
  background:linear-gradient(160deg,var(--ink) 0%,var(--ink2) 100%);
  color:var(--soft);padding:4rem 1.5rem 2rem;
  position:relative;overflow:hidden;
}
footer::before{
  content:'';position:absolute;top:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,var(--blue-dk),var(--blue),var(--blue-lt));
}
.ftin{max-width:1120px;margin:0 auto}
.ftt{display:grid;grid-template-columns:minmax(0,2.5fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr);gap:4rem;padding-bottom:2.5rem;border-bottom:1px solid rgba(255,255,255,.08)}
.flt{font-family:'Plus Jakarta Sans',sans-serif;font-size:1.05rem;font-weight:800;color:#fff}
.flt .flt-in{color:#93C5FD}
.ftag{font-size:.86rem;color:var(--soft);line-height:1.75;margin-top:.75rem;max-width:280px}
.fh{font-size:.68rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#93C5FD;margin-bottom:1.1rem}
.flks{list-style:none;display:flex;flex-direction:column;gap:.5rem}
.flks button,.flks a{background:none;border:none;cursor:pointer;text-align:left;padding:0;font-family:'DM Sans',sans-serif;font-size:.86rem;color:var(--soft);transition:color .2s;text-decoration:none}
.flks button:hover,.flks a:hover{color:#fff}
.ftb{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:1rem;margin-top:2rem}
.fcp{font-size:.77rem;color:rgba(255,255,255,.35)}

/* ── SPOT GRID (Funzionalita spotlight) ── */
.spot-grid{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:4rem;align-items:center}

/* ── NAME ROW (Contatti nome+cognome) ── */
.name-row{display:grid;grid-template-columns:1fr 1fr;gap:1rem}

/* ── QUICK FAQ GRID (Prezzi) ── */
.qfaq-grid{display:grid;grid-template-columns:1fr 1fr;gap:1.5rem}

/* ── ANIMATIONS ── */
.an{opacity:0;transform:translateY(24px);transition:opacity .65s ease,transform .65s ease}
.an.in{opacity:1;transform:translateY(0)}
.d1{transition-delay:.08s}.d2{transition-delay:.18s}.d3{transition-delay:.28s}
.d4{transition-delay:.38s}.d5{transition-delay:.48s}.d6{transition-delay:.58s}

/* ══════════════════════════════════════════
   RESPONSIVE  960 / 768 / 600 / 420
══════════════════════════════════════════ */

@media(max-width:960px){
  .nav-links{display:none}
  .hb{display:flex}
  .hero{padding:7rem 1.25rem 4rem}
  .hero-in{grid-template-columns:minmax(0,1fr)}
  .browser{max-width:480px;margin:2.5rem auto 0}
  .hero-badge{left:.6rem;bottom:1.1rem;max-width:190px;padding:.6rem .8rem}
  .sbar-in{grid-template-columns:repeat(2,minmax(0,1fr))}
  .si:nth-child(2){border-right:none}
  .si:nth-child(3){border-top:1px solid var(--border)}
  .fg{grid-template-columns:repeat(2,minmax(0,1fr))}
  .sg{grid-template-columns:minmax(0,1fr)}
  .spot-grid{grid-template-columns:minmax(0,1fr);gap:2.5rem}
  .pg{grid-template-columns:minmax(0,1fr);max-width:480px;margin:3rem auto 0}
  .pc.pop{transform:none;box-shadow:0 8px 32px rgba(37,99,235,.15)}
  .qfaq-grid{grid-template-columns:minmax(0,1fr)}
  .cth,.ctr{grid-template-columns:minmax(0,1.6fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)}
  .tg2{grid-template-columns:repeat(2,minmax(0,1fr))}
  .cg{grid-template-columns:minmax(0,1fr);gap:2.5rem}
  .ftt{grid-template-columns:repeat(2,minmax(0,1fr));gap:2.5rem}
}

@media(max-width:768px){
  .sec{padding:4.5rem 1.25rem}
  .ph{padding:7rem 1.25rem 3.5rem}
  .hero{padding:6.5rem 1.25rem 3.5rem}
  .hero-p{font-size:1rem}
  .hero-btns{flex-direction:column;align-items:flex-start;gap:.6rem}
  .hero-btns .btn{width:100%;justify-content:center}
  .browser{max-width:420px;margin:2rem auto 0}
  .fg{grid-template-columns:minmax(0,1fr)}
  .tg2{grid-template-columns:minmax(0,1fr)}
  .pg{max-width:100%}
  .ctw{overflow-x:auto;-webkit-overflow-scrolling:touch}
  .cth,.ctr{min-width:520px}
  .name-row{grid-template-columns:minmax(0,1fr)}
  .ftt{grid-template-columns:minmax(0,1fr);gap:2rem}
  .ftb{flex-direction:column;text-align:center;gap:.5rem}
}

@media(max-width:600px){
  .nav-in{padding:0 .85rem}
  .nav-r{gap:.4rem}
  .nav-r .btn{padding:.52rem .9rem;font-size:.83rem;border-radius:8px}
  .hb{padding:.4rem}
  .hb span{width:22px;height:2px}
  .sec{padding:3.5rem 1rem}
  .ph{padding:6rem 1rem 3rem}
  .hero{padding:6rem 1rem 3rem}
  .lead{font-size:.97rem}
  .browser{max-width:100%;margin:1.75rem auto 0}
  .bcars{gap:.5rem;padding:.7rem .85rem}
  .sbar{padding:0 1rem}
  .si{padding:1.5rem 1rem}
  .si-n{font-size:1.8rem}
  .fc{padding:1.4rem}
  .sc-card{padding:1.35rem}
  .cta{padding:4rem 1rem}
  .cta .btn-lg{width:100%;justify-content:center}
  .pg{max-width:100%;margin:2rem 0 0}
  .pc{padding:1.5rem}
  .fcard{padding:1.5rem}
  footer{padding:3rem 1rem 1.5rem}
  .cth,.ctr{min-width:460px}
  .tc2::before{font-size:3rem;top:.5rem;left:1.1rem}
}

@media(max-width:420px){
  .nav-in{padding:0 .55rem}
  .nav-logo img{height:25px!important}
  .nav-r{gap:.32rem}
  .nav-r .btn{padding:.46rem .75rem;font-size:.78rem;border-radius:7px}
  .hb{padding:.35rem}
  .hb span{width:20px;height:1.8px}
  .hero-proof{flex-direction:column;gap:.75rem}
  .btn-lg{padding:.85rem 1.4rem;font-size:.88rem}
  .pg{margin:1.5rem 0 0}
  .cth,.ctr{min-width:400px}
}
@media(max-width:360px){
  .nav-in{padding:0 .4rem}
  .nav-r{gap:.25rem}
  .nav-r .btn{padding:.42rem .62rem;font-size:.74rem}
}
`;

